module.exports = __webpack_public_path__ + "static/media/depressaoMobile.0a4cf26d.png";